import React from 'react';

const HeaderText = ({ title, subtitle }) => {
  return (
    <div className="min-w-0">
      <h3 className="truncate font-semibold tracking-wide text-slate-900 ">{title}</h3>
      {subtitle && <p className="truncate text-sm text-slate-500 ">{subtitle}</p>}
    </div>
  );
};

export default React.memo(HeaderText);
